import { apiRequest } from '@utils/request';
import { AxiosResponse } from 'axios';

export async function getOfferingIdFromSlug(urlSlug: string): Promise<{ id: string }> {
	const response = await apiRequest.get(`/offering/${urlSlug}/offering-from-url-slug`, {
		suppressToast: (resp: AxiosResponse) => resp.status === 404
	});
	return response.data;
}
